<template>
    <div>
        <div class="ProductOnSale">
            <div style="display: flex;">
                <!--<el-select v-model="state" placeholder="请选择" size="mini" @change="changeState">
                    <el-option
                            v-for="item in stateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>-->
                <el-input
                        style="width: 220px"
                        size="mini"
                        class="input"
                        placeholder="搜索标题"
                        v-model="vc_search"
                        clearable>
                </el-input>
                <el-button class="mrl20" style="margin-left: 10px" icon="el-icon-search" circle  @click="searchData" size="mini"></el-button>
                <!--<el-select v-model="state" placeholder="请选择" size="mini">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>-->
                <el-button class="marB10" @click="addZB" :class="baseerp+'btn'" size="mini">
                    新增招标
                </el-button>
            </div>
        <el-table
                class="mrt10"
                ref="table"
                size="mini"
                :height="tableHeight"
                border
                :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="true"
                style="width: 100%">
            <!--<el-table-column
                    label="编号"
                    align="center"
                    prop="code" show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    align="center"
                    label="标题"
                    prop="vc_code" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.vc_code+'-'+scope.row.vc_type}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="招标时间"
                    width="180"
                    sortable
                    prop="dt_createtime" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="截标时间"
                    width="180"
                    sortable
                    prop="dt_deadline" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="录入人"
                    width="120"
                    prop="vc_lruname" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="file_name"
                    label="模板附件"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <!--<div style="display: block" >
                        <el-button v-if="scope.row.vc_files" type="text" @click="downloadExcel(scope.row)">{{scope.row.vc_files.vc_name}}</el-button>
                    </div>-->
                    <a
                            v-if="scope.row.vc_files"
                            :download="scope.row.vc_files.vc_name"
                            mce_href="#"
                            :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+scope.row.vc_files.vc_newname+'\'}','utf-8')">
                                                {{scope.row.vc_files.vc_name}}
                        <!--<i class="el-icon-paperclip" v-show="item.vc_name"></i>-->
                    </a>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.i_ispublish==0"  size="mini" type="text" @click="tofb(scope.row)">发布</el-button><!-- -->
                    <el-button  size="mini" type="text" @click="copy(scope.row)">复制</el-button>
                    <el-button v-if="scope.row.i_ispublish==0"  size="mini" type="text" @click="todetails(scope.row)">编辑</el-button>
                    <el-button v-if="scope.row.i_open_able==1"  size="mini" type="text" @click="details(scope.row)">开标</el-button>

                    <!--<el-button v-if="(scope.row.state==2||scope.row.state==4||scope.row.state==5)&&scope.row.i_isbargaining==1"  size="mini" type="text" @click="lookreport(scope.row)" >查看报价</el-button>-->
                    <!--<el-button  size="mini" type="text" @click="stopAccept(scope.row)" v-if="scope.row.state==2" :disabled="disrow">截止</el-button>-->
                    <!--<el-button  size="mini" type="text" v-if="scope.row.state==1" @click="fabu(scope.row)" :disabled="disrow">发布</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        layout="total,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total"
                        :page-size="pageSize">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog :title="title"
                       width="800px"
                       top="30px"
                       :visible.sync="dialogTableVisible"
                       :close-on-click-modal="false"
                       @close="closeDetailsFun"
                       v-if="dialogTableVisible">
                <add-page :data="tenderData" @close="closeDetailsFun"></add-page>
            </el-dialog>
        </div>
        <div :class="baseerp+'div'">
            <el-dialog :title="fbtitle"
                       width="800px"
                       top="30px"
                       :visible.sync="dialogTableVisible_fb"
                       :close-on-click-modal="false"
                       @close="closefb"
                       v-if="dialogTableVisible_fb">
                <fb-detail :data="detailData" @close="closefb"></fb-detail>
            </el-dialog>
        </div>
        <div class="contentLeft">
            <reportdialog  ref="mydialog"  ></reportdialog>
            <eDialog ref="eDialog" :activePage="activePage"></eDialog>
        </div>
    </div>
    </div>
</template>

<script>
    import * as API from "../api";
    import {baseerp,baseApp,file_url,baseVersion,file_root} from "@/utils/baseUrl";/*reportfileUrl,MD5KEY,*/
    import {mapActions} from "vuex";
    import addPage from "./addPage";
    import fbDetail from "./fbDetail";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    import spd from '../../../spreadJs/spreadview.js';
    import md5 from 'js-md5';
    export default {
        name: "index",
        components: {
            addPage,
            reportdialog,
            eDialog,
            fbDetail
        },
        data() {
            return {
                detailData:{},
                fbtitle:'',
                dialogTableVisible_fb:false,
                tenderData:{},
                tableData:[],
                treespan:4,
                rightspan:20,
                showDetails:false,
                baseerp:'',
                token:'',
                i_uid:'',
                file_url: '',
                MD5KEY:"",
                reportfileUrl:'',
                file_root:'',
                baseApp:"",
                baseVersion:"",
                dialogTableVisible:false,
                pageSize:20,
                currentPage:0,
                total:0,
                title:'新增招标',
                state:null,
                stateList:[
                    {value:null,label:'全部状态'},
                    {value:0,label:'未提交'},
                    {value:1,label:'可发布'},
                    {value:3,label:'招标审批中'},{value:2,label:'招标中'},

                    {value:4,label:'开标中'},
                    {value:5,label:'招标结束'},
                    {value:-2,label:'未通过'},
                ],
                tableHeight:0,
                disrow:false,
                activePage:"report/res/spread.vue",
                vc_search:'',
            }
        },
        mounted() {
            this.baseerp=baseerp;
            this.i_uid= sessionStorage.getItem("userid");
            this.token=sessionStorage.getItem("token");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            //this.MD5KEY = MD5KEY;
            //this.reportfile_url = reportfileUrl;
            this.file_root = file_root;
            //console.log(this.reportfile_url,'this.reportfile_url')
            //console.log(this.MD5KEY,'this.MD5KEY')
            this.bidsList();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            closefb(val){
                this.dialogTableVisible_fb=false;
                this.detailData={};
                if(val=='save'){
                    this.currentPage=1;
                    this.vc_search='';
                    this.bidsList();
                }
            },
            tofb(row){
                this.fbtitle="发布 "+row.vc_code+'-'+row.vc_type+" "+row.dt_deadline+'时间截标';
                this.dialogTableVisible_fb=true
                this.detailData={
                    data:row,
                };
            },
            addZB(){
                this.title="新增招标"
                this.dialogTableVisible=true
                this.tenderData={
                    i_id:0,
                    state:0,
                    i_mid:this.mid,
                    copydata:null,
                };
            },
            todetails(row){
                this.title="招标详情"
                this.dialogTableVisible=true
                this.tenderData={
                    i_id:row.i_id,
                    state:0,
                    i_mid:this.mid,
                    copydata:row,
                };
            },
            copy(row){
                this.title="新增招标"
                this.dialogTableVisible=true
                this.tenderData={
                    i_id:0,
                    state:0,
                    i_mid:this.mid,
                    copydata:row,
                };
            },
            details(row){
                /*this.tenderData=row;
                this.tenderData.i_mid=this.mid
                this.dialogTableVisible=true
                this.title="查看标"+row.code+"详情"*/
                this.openTender(row)
            },
            async openTender(row){
                this.disrow=true;
                let param={
                    i_id:row.i_id,
                };
                let res=await API.openTender(param);
                if ( res.code == 1 ){
                    // this.disrow=false
                    this.$message.success(res.message);
                    this.bidsList()
                }else if (res.code == -2) {
                    this.disrow=false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disrow=false
                    this.$message.error(res.message);
                }
            },
            clearFile(val,index){
                this.formData.vc_files.otherfiles.splice(index,1)
                // this.formData.vc_files.otherfiles=[]
                this.$forceUpdate()
            },
            downloadExcel(row){
                var md = md5(row.vc_files.vc_newname+this.MD5KEY);
                var MD = md.toString().toUpperCase();
                //console.log('MD',MD)
                //console.log('row',row)
                //let a = document.createElement('a')
                //console.log( this.reportfile_url,' this.reportfile_url');
                //a.href = this.reportfile_url+'/'+row.vc_newname+'/'+MD;
                //a.click();
                window.location.href = this.reportfile_url+'/'+row.vc_files.vc_newname+'/'+MD+row.vc_files.vc_newname;
            },
            //另存为（本地保存）
            locationSave(){
                let ex = spd.excelIO_spd;
                //console.log(spd,"spd");
                //console.log(ex,"ex");
                let json =spd.spread.toJSON({includeBindingSource:true});
                //console.log(json,"json");
                const that=this;
                ex.save(json, function (blob) {
                    //console.log(blob,"blob");
                    FaverSaver.saveAs(blob, 'export.xlsx');
                }, function (e) {
                    //console.log(e,"12345")
                });
                //console.log(ex.save,"save");
            },
            lookreport(row) {
                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});

                this.$refs.eDialog.showDialog({
                    title:"报价明细结果报表",
                    parm:{type:'RequireOfferRpt',mid:this.$route.meta.mid,arg:{i_bid_id:row.id}},
                    w:1024,
                    h:768
                });
                loading.close();
                document.addEventListener('click',function(e){
                    loading.close()
                });
                // console.log(res)
            },
            changeState(val){
                this.state=val
                this.currentPage=1
                this.bidsList()
            },
            searchData(){
                this.currentPage=1
                this.bidsList()
            },
            async bidsList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id);
                } else {
                    this.mid = sessionStorage.getItem('mids');
                }
                let param={
                    i_mid: this.mid,
                    //id:0,
                    //pzId:0,
                    //i_state:this.state,
                    //keyword:'',
                    //duetime:'',
                    pageSize:this.pageSize,
                    currentPage:this.currentPage,
                    //isPublished:0,
                    vc_search:this.vc_search
                };
                let res=await API.tenderlist(param);
                if ( res.code == 1 ){
                    this.disrow=false
                    // console.log(res.data.list)
                    this.tableData=res.data.list;
                    this.total=res.data.total;
                    // console.log(this.tableData,"this.tableData")
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            async stopAccept(row){
                this.disrow=true
                let param={
                    id:row.id,
                };
                let res=await API.stopAccept(param);
                if ( res.code == 1 ){
                    // this.disrow=false
                    this.$message.success(res.message);
                    this.bidsList()
                }else if (res.code == -2) {
                    this.disrow=false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disrow=false
                    this.$message.error(res.message);
                }
            },
            async fabu(row){
                this.disrow=true
                let param={
                    id:row.id,
                };
                let res=await API.publish(param);
                if ( res.code == 1 ){
                    // this.disrow=false
                    this.$message.success(res.message);
                    this.bidsList()
                }else if (res.code == -2) {
                    this.disrow=false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disrow=false
                    this.$message.error(res.message);
                }
            },

            showDetailsFun(){
                this.dialogTableVisible=true
            },
            closeDetailsFun(type='back'){
                this.dialogTableVisible=false
                this.tenderData={}
                if(type=='save'){
                    this.currentPage=1;
                    this.vc_search='';
                    this.bidsList()
                }
            },
            refresh(){
                if(this.tenderData.i_id==0){
                    this.currentPage=1
                }
                this.bidsList()
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.bidsList();
            },
        },

    }
</script>

<style lang="scss" scoped>
    .ProductOnSale{
        margin: 10px 14px;
    }
    .mrt10{
        margin-top: 10px;
    }
    /deep/{
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-dialog{
            margin:30px auto;
        }
    }
</style>